/* eslint-disable no-template-curly-in-string */
// TODO: Use context api.
export const CONTENT = Object.freeze({
  PLATFORM_ORDER_ID: '訂單編號', // Same as order id.
  PLATFORM_RETURN_ID: '退貨編號', // Same as return id.
  PLATFORM_STATUS: '訂單狀態',
  TRACKING_NO: '物流單號', // Same as logistics number.
  SUPPLIER_ID: '供應商 ID',
  SUPPLIER_NAME: '供應商名稱',
  ORDER_DATES: '訂單日期',
  OUTPUT_FIELDS: '匯出欄位',
  EMAIL: '電子郵件',
});

export const PAGE_TITLE = Object.freeze({
  OPT_ORDER_DOWNLOAD: '訂單下載 / OTP發送紀錄',
  ANNOUNCEMENT_CONSENT: '公告同意 / 查看紀錄',
  PERSONAL_DATA: '個資查看紀錄',
});
